module.exports = __webpack_public_path__ + "static/media/workshop_past_emptystate.b4a12c05.svg";